import i18n from "@/i18n";

export const selectInstanceGroupsFields = [
    {
        key: "name",
        label: i18n.t("instanceGroups.name"),
        tdClass: "text-left",
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    }
];
